import React, { CSSProperties, MouseEventHandler } from 'react';
import { Link, useNavigate } from 'react-router-dom';

type Props = {
  to?: string;
  text?: string;
  containerStyle?: CSSProperties;
  colorScheme?: 'primary' | 'secondary' | 'orange';
  variant?: 'default' | 'inverse';
  disabled?: boolean;
  onClick?: (
    event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>,
  ) => void;
};

export const Button: React.FC<Props> = ({
  to,
  onClick,
  containerStyle,
  text = 'Button',
  colorScheme = 'primary',
  variant = 'default',
}) => {
  const navigate = useNavigate();

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    if (to === 'back') {
      event.preventDefault();
      navigate(-1);
    } else if (onClick) {
      onClick(event);
    }
  };

  const style: CSSProperties = {
    height: 50,

    backgroundColor:
      variant === 'inverse'
        ? '#000'
        : colorScheme === 'primary'
          ? '#fff'
          : colorScheme === 'secondary'
            ? '#ffdec6'
            : colorScheme === 'orange'
              ? '#f9791d'
              : '#000',
    color:
      variant === 'inverse'
        ? '#fff'
        : colorScheme === 'orange' && text === 'Guests'
          ? '#fff'
          : colorScheme === 'orange' && text === 'Place Order'
            ? '#000'
            : colorScheme === 'primary' || colorScheme === 'secondary'
              ? '#000'
              : '#fff',

    borderRadius: 6,

    border: `1px solid ${colorScheme === 'orange'
      ? '#f9791d#f9791d'
      : colorScheme === 'secondary'
        ? '#f9791d'
        : '#000'
      }`,


    fontFamily: 'Poppins',
    fontWeight: colorScheme === 'secondary' || colorScheme === 'orange' && text === 'Place Order' ? 500 : 800,
    fontSize: 14,
    cursor: 'pointer',
    margin: '0 auto',
    textAlign: 'center',
    textTransform: 'capitalize',
    width: colorScheme === 'orange' && text === 'Place Order' ? '65%' : '100%',
    userSelect: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...containerStyle,
  };

  if (to) {
    return (
      <Link
        to={to}
        style={{ ...style }}
        onClick={handleClick}
      >
        {text}
      </Link>
    );
  }

  if (!to) {
    return (
      <button
        style={{ ...style }}
        onClick={onClick}
      >
        {text}
      </button>
    );
  }

  return null;
};
